<div class="container webview text-center" [@flyInOut]="'in'">
  <div class="col-sm-12 pt-5">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub2}}</h1>
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub3}}.</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub4}}</h1>
  </div>
  <div class="col-sm-12">
    <div class="form-group col-sm-4 m-auto px-0">
      <input type="text" IsAlphaNumeric class="form-control" [(ngModel)]="firstname" maxlength="25" placeholder="First Name"
        (keydown.space)="firstname ? null : $event.preventDefault()" (keyup)="enableButton($event)" (keyup.enter)="getFirstname();"/>
    </div>
    <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton col-sm-4 mt-4 font22 text-uppercase mx-4"
      [ngClass]="{'combtn': disablebutton}"
      (click)="getFirstname();">Next</button>
  </div>
</div>
<div class="container mobileview px-0 pt-4" style="float:left;">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{questionObj.com_question_mob}}</h1>
      </div>
    </div>
  </div>
  <br />
  <div class="col-10 pull-right pl-4 mb-2">
    <form #f="ngForm" (ngSubmit)="getFirstname();" novalidate>
      <div class="form-group float-label-control">
        <input class="focus-none form-control" type="text" IsAlphaNumeric name="firstname" [(ngModel)]="firstname" maxlength="25" 
          placeholder="First Name" id="firstname" (focusout)="getFirstname();" (keydown.space)="firstname ? null : $event.preventDefault()"
          (keyup.enter)="getFirstname(); $event.target.blur();">
          <label for="firstname">First Name</label>
      </div>
    </form>
  </div>
</div>